<template>
  <div class="c-product-card type-horizontal">
    <div class="product-thumb">
      <button
        type="button"
        class="thumb-button"
        @click="() => emits('select', data.product)"
      >
        <div class="product-img">
          <img
            v-if="isNoPcImage"
            src="@/assets/images/common/img_no_product.svg"
            alt="No Image"
            class="no-image"
          />
          <img
            v-else
            :src="imageFilePath"
            alt=""
            @error="() => (imageErrorYn = true)"
          />
        </div>
        <div class="thumb-bottom">
          <p class="text">제품상세</p>
          <i class="c-icon icon-plus"></i>
        </div>
      </button>
    </div>
    <div class="product-info">
      <div class="c-product-badge">
        <span v-show="data.product.setgdYn === 'Y'" class="badge type-skyblue">
          SET 제품
        </span>
        <span v-if="data.product.zzlqdCls == 'A'" class="badge type-purple">
          주제
        </span>
        <span v-if="data.product.zzlqdCls == 'B'" class="badge type-mint">
          경화제
        </span>
        <span v-if="data.product.zzlqdCls == 'C'" class="badge type-blue">
          경화촉진제
        </span>
        <span v-if="data.product.zzlqdCls == 'D'" class="badge type-violet">
          회석제
        </span>
        <span v-if="data.product.zzlqdtyCls == 'A'" class="badge type-olive">
          1액형
        </span>
        <span v-if="data.product.zzlqdtyCls == 'B'" class="badge type-olive">
          2액형
        </span>
        <span v-if="data.product.zzlqdtyCls == 'C'" class="badge type-olive">
          3액형
        </span>
      </div>
      <div class="c-product-category">
        <span class="path"> {{ data.product.prodh1t }} </span>
        <span class="path"> {{ data.product.prodh2t }} </span>
        <span class="path"> {{ data.product.prodh3t }} </span>
      </div>
      <div class="product-code">{{ data.product.matnr }}</div>
      <strong class="product-name"> {{ data.product.zzmaktx }} </strong>
      <div class="info-bottom">
        <div class="c-btn-area type-product">
          <button
            type="button"
            class="c-button type-white type-xsmall type-icon"
            @click="() => emits('cart', { ...data.product, quantity: 1 })"
          >
            <i class="c-icon icon-basket-product"></i>
            <span class="sr-only">장바구니</span>
          </button>
          <button
            type="button"
            class="c-button type-primary type-xsmall"
            @click="() => emits('buy', { ...data.product, quantity: 1 })"
          >
            <span>바로주문</span>
          </button>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="btn-delete"
      @click="() => emits('delete', { ...data.product })"
    >
      <i class="c-icon icon-small-x"></i>
      <span class="sr-only">최근 본 제품 지우기</span>
    </button>
  </div>
</template>
<script setup>
import {
  onMounted,
  defineProps,
  defineEmits,
  computed,
  reactive,
  ref,
} from "vue";
import Utils from "@/js/utils";

const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
const imageErrorYn = ref(false);

const props = defineProps({
  product: {
    type: Object,
    require: true,
  },
});

const emits = defineEmits(["buy", "cart", "select", "delete"]);

const data = reactive({
  product: {},
});

onMounted(() => {
  data.product = props.product;
});

const isNoPcImage = computed(() => {
  return (
    Utils.isBlank(data.product.imgFilePath) ||
    Utils.isBlank(data.product.imgFileNm) ||
    imageErrorYn.value
  );
});

const imageFilePath = computed(() => {
  return (
    FILE_CDN_URL + "/" + data.product.imgFilePath + "/" + data.product.imgFileNm
  );
});
</script>
